import {ajaxGetData} from 'methods/ajaxData';
import {MAX_ICON_WHITE_24} from 'components/tourist-leads/icons';
import metrikaCollector, {collectYandexReachGoal} from 'components/metrika';

const ACTION_SELECTOR = '.Support__content-action';
const BUTTON_CLASS = 'js-support-max-button';
const SUPPORT_ROOT_SELECTOR = '.Support';

function reachSupportBannerGoal(goal) {
    if (typeof yaCounter46243086 === 'undefined') {
        return;
    }

    yaCounter46243086.reachGoal(goal);
    collectYandexReachGoal(metrikaCollector, goal);
}

/**
 * Цели Метрики по кликам в баннере подбора (Support).
 */
export function initSupportBannerMetrika() {
    document.addEventListener('mousedown', (e) => {
        if (e.target.closest(`${SUPPORT_ROOT_SELECTOR} .${BUTTON_CLASS}`)) {
            reachSupportBannerGoal('max_click_banner');
            return;
        }

        if (e.target.closest(`${SUPPORT_ROOT_SELECTOR} ${ACTION_SELECTOR} a[href^="tel:"]`)) {
            reachSupportBannerGoal('phone_click_banner');
        }
    });
}

function renderMaxButton(maxLink) {
    return `
        <a class="Support__content-action-max ${BUTTON_CLASS}"
           href="${maxLink}"
           target="_blank"
           rel="noopener noreferrer"
        >
            <span class="Support__content-action-max-icon">${MAX_ICON_WHITE_24}</span>
            Написать в MAX
        </a>
    `;
}

function injectMaxButton($action, maxLink) {
    if (!$action || $action.querySelector(`.${BUTTON_CLASS}`)) {
        return;
    }

    $action.insertAdjacentHTML('afterbegin', renderMaxButton(maxLink));
}

function injectIntoDocument(maxLink) {
    document.querySelectorAll(ACTION_SELECTOR).forEach(($action) => {
        injectMaxButton($action, maxLink);
    });
}

/**
 * Кнопка «Написать в MAX» в баннер подбора.
 * Всегда чат-бот MAX (как SidePhones на карточке объекта).
 * Статика баннера кешируется / собирается в JS — ссылку берём из get_ajax_data.
 */
export function initSupportMaxButtonFromAjax() {
    ajaxGetData().then((r) => {
        if (r.status != 'ok' || !r.data?.max_link) {
            return;
        }

        const maxLink = r.data.max_link;

        injectIntoDocument(maxLink);

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType != 1) {
                        return;
                    }

                    if (node.matches?.(ACTION_SELECTOR)) {
                        injectMaxButton(node, maxLink);
                        return;
                    }

                    node.querySelectorAll?.(ACTION_SELECTOR).forEach(($action) => {
                        injectMaxButton($action, maxLink);
                    });
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    });
}
